
import {
  scrubbingCenter,
  firewall,
  needs,
  popularServices,
  questions,
} from "~/data/waf";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  components: {
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خرید WAF ابری آبالون | امنیت پایدار با فایروال وب اپلیکیشن",
      meta: [
        {
          name: "description",
          content:
            "راهکار WAF (فایروال وب اپلیکیشن) آبالون | تضمین امنیت وب سایت شما |‌ رول‌ست‌های اختصاصی | از حملات امنیتی مانند SQL Injection ،XSS و DDoS در امان باشید‌",
        },
        {
          name: "keywords",
          content:
            "راهکار WAF, فایروال وب اپلیکیشن, فایروال وب, دیوار آتش وب, وب فایروال WAF",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/waf",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "خرید WAF ابری آبالون | امنیت پایدار با فایروال وب اپلیکیشن",
        },
        {
          property: "og:description",
          content:
            "راهکار WAF (فایروال وب اپلیکیشن) آبالون | تضمین امنیت وب سایت شما |‌ رول‌ست‌های اختصاصی | از حملات امنیتی مانند SQL Injection ،XSS و DDoS در امان باشید‌",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/waf",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title: "خرید WAF ابری آبالون | امنیت پایدار با فایروال وب اپلیکیشن",
        },
        {
          name: "twitter:description",
          content:
            "راهکار WAF (فایروال وب اپلیکیشن) آبالون | تضمین امنیت وب سایت شما |‌ رول‌ست‌های اختصاصی | از حملات امنیتی مانند SQL Injection ،XSS و DDoS در امان باشید‌",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/waf",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "آیا برای استفاده از WAF آبالون نیاز به خرید تجهیزات خاصی هست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "خیر. WAF آبالون یک سرویس ابری است و نیازی به نصب یا نگهداری سخت‌افزار در سمت شما ندارد. همه ‌چیز از طریق پنل مدیریت CDN آبالون در اختیار شما قرار می‌گیرد.",
                },
              },
              {
                "@type": "Question",
                name: "چه نوع حملاتی توسط WAF شناسایی و مسدود می‌شوند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "حملاتی از جمله SQL Injection، XSS، DoS، DDoS، RFI، LFI و درخواست‌های مشکوک بات‌ها، همگی توسط WAF آبالون به‌صورت بلادرنگ شناسایی و دفع می‌شوند.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت رول‌ست‌های COMODO، CRS و ABALON چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "رول‌ست COMODO برای مقابله با تهدیدات رایج، CRS برای پوشش وسیع‌تر تهدیدات و ABALON برای تنظیمات اختصاصی و پیشرفته توسعه داده شده‌اند. استفاده ترکیبی از هر ۳ رول‌ست، بالاترین سطح امنیت را فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان تنظیمات WAF را برای نیازهای خاص سازمانی سفارشی کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با رول‌ست اختصاصی ABALON می‌توانید تنظیمات امنیتی را به‌صورت دقیق و متناسب با ساختار و نیاز سازمان خود شخصی‌سازی کنید.",
                },
              },
              {
                "@type": "Question",
                name: "قابلیت Rate Limit در WAF آبالون چه کاربردی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با Rate Limit می‌توانید تعداد درخواست‌ها به مسیرهای خاص (مثل صفحات ورود) یا از IPهای خاص را محدود کنید. این قابلیت از سوءاستفاده و حملات DoS جلوگیری کرده و از منابع سیستم محافظت می‌کند.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "خرید WAF ابری آبالون | امنیت پایدار با فایروال وب اپلیکیشن",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      scrubbingCenter,
      firewall,
      needs,
      popularServices,
      questions,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
    showMore() {
      this.showmore = true;
    },
  },
};
